import styled from '@emotion/styled/macro';
import { colors } from '../../../../common/styles/theme.styles';

export const GuideContainer = styled.div`
  position: relative;
  background: #fff;
  border: 1px solid ${colors.gray3};
  border-radius: 12px;
  width: 100%;
`;

export const GuideTitle = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-family: Circular;
  font-weight: 700;
  font-size: 22px;
  line-height: 1em;
  letter-spacing: -1.32px;
  color: ${colors.darkGray1};
  margin: 0 0 31px;
  padding: 12px 20px 0;
`;

export const GuideDiagram = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0;
  margin: 0;
  padding: 0 20px;
`;

export const GuideLearnMore = styled.button`
  display: flex;
  align-items: center;
  gap: 8px;
  white-space: nowrap;
  padding: 0px 8px 0px 12px;
  background: ${colors.lightGray2}; 
  color: ${colors.darkGray2};
  border: none;
  border-radius: 8px;
  font-family: Circular;
  font-weight: 450;
  font-size: 14px;
  line-height: 1.26;
  cursor: pointer;
  transition: background-color 0.2s ease;
  height: 32px;
  
  &:hover {
    background: ${colors.lightGray2}; 
  }
  
  svg {
    width: 16px;
    height: 16px;
  }
`; 